// Home
import { setToken, getToken, removeToken } from '@/utils/token'
import { login, register, getCode } from '@/api/user.js'
import { Message } from 'element-ui';
import router from '@/router';
const state = {
    token: getToken(),
    // 用户信息
    userInfo: {},
    userLogout: {},
    // 选择按钮
    activeId: 1,
    /**
     * 登录、注册弹出切换
     * 1 登录 2注册 3忘记密码
     */
    isLoginOrRegister: 1,
    // 控制弹框
    visibleDialog: false,

}
// 修改state数据
const mutations = {
    UserInfo(state, userInfo) {
        state.userInfo = userInfo
    },
    // 清除本地数据
    CLEAR(state) {
        state.token = ''
        state.userInfo = ''
        removeToken()
    },
    HANLE_ACTIVE_ID(state, id) {
        state.activeId = id
    },
    /**
     * 修改登录、注册弹出切换
     * @param {*} status  1 登录 2注册 3忘记密码
     */
    HANLE_IS_LOGIN_OR_REGISTER(state, status) {
        console.log(status);
        state.isLoginOrRegister = status
    },
    // 控制弹框
    HANLE_VISIBLE_DIALOG(state, visibleDialog) {
        state.visibleDialog = visibleDialog
    }
}
// 处理异步
const actions = {
    async userLogin({ commit }, ruleForm) {
        let res = await login(ruleForm)
        if (res.success) {
            // 存储token
            setToken(res.entity.token)
            // 存储用户信息
            commit('UserInfo', res.entity)
            localStorage.setItem('userInfo', JSON.stringify(res.entity))
        }
    },
    // 注册
    async usreRegister({ commit }, ruleForm) {
        let res = await register(ruleForm)
        if (res.success) {
            Message.success(res.message)
            setTimeout(() => {
                commit("HANLE_IS_LOGIN_OR_REGISTER");
            }, 800);
        }
    },
    /**
     * 获取验证码
     */
    async getLoginCode({ commit }, phone) {
        let res = await getCode(phone)
        if (res.success) {
            Message.success(res.message)
        }
    },
    


    // tab切换
    handleActiveId({ commit }, id) {
        commit('HANLE_ACTIVE_ID', id)
    },
    // 退出登录
    userLogout({ commit }) {
        commit('CLEAR')
    },

}
const getters = {
}
export default {
    state,
    getters,
    mutations,
    actions
}